import React from 'react';
import Popover from 'components/pure/utils/Popover';
import classNames from 'classnames';
import SharingFormActions from 'actions/sharing/SharingFormActions';

/**
 * `FileUploadSharingDialogFormComments` renders a textarea and updates
 * in `FileUploadSharingDialogFormStore` as part of the total sharing
 */
class FileUploadSharingDialogFormComments extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      comments: '',
    };
  }

  /**
   * Callback triggered when the user changes the content of comments according to `event`
   * @param  {Event} event An event object
   */
  onCommentsChange = event => {
    this.setState({comments: event.currentTarget.value});
    SharingFormActions.updateComments(event.currentTarget.value);
    this.props.onDataChanged();
  };

  render() {
    const placeholder =
      "Explain why you're sharing the call. " +
      "Point out the areas that are relevant to whoever you're sharing the call with.";
    const additionalClassNames = this.props.error ? ['error-field'] : [];
    const {errorAnchor} = this.props;
    const anchor = errorAnchor || this.commentsField;
    // I know it looks weird to have the ?: operator return the same value no matter the condition,
    // but it makes sense to keep the code because depending on the component's placement in the form
    // the vertical position when there is an errorAnchor can be "top" or "bottom", and the placement can change
    // as it does now, it was at the bottom. Ideally of course this should be parameterized.
    const targetOrigin = {
      horizontal: 'left',
      vertical: errorAnchor ? 'top' : 'top',
    };
    // When we have an errorAnchor, we set the label to not "comments". By doing this we are indicating to
    // FileUploadSharingDialogForm.onPopoverRef that it is the popover at the errorAnchor reporting location,
    // so no need to consider whether it is inbounds or not.
    const label = errorAnchor ? '' : 'comments';

    return (
      <label className="overflow ev-text-area-field">
        <div className="text-input-label">Why are you sharing this call?</div>
        <div className="comments-textarea">
          <textarea
            className={classNames('textarea', additionalClassNames)}
            tabIndex={this.props.tabindex}
            value={this.state.comments}
            onChange={this.onCommentsChange}
            placeholder={placeholder}
          />
          <div className="error-anchor" ref={c => (this.commentsField = c)} />
          <Popover
            open={!!this.props.error}
            canAutoPosition={false}
            useLayerForClickAway={false}
            anchorEl={anchor}
            anchorOrigin={{horizontal: 'right', vertical: 'top'}}
            targetOrigin={targetOrigin}>
            <div
              className="sharing-dialog-popover-error-message"
              ref={c => this.props.onPopoverRef(label, c)}>
              {this.props.error}
              {this.props.errorAnchor && <div className="more-errors-up"> (Please scroll up)</div>}
            </div>
          </Popover>
        </div>
      </label>
    );
  }
}

export default FileUploadSharingDialogFormComments;
